import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ErrorContext } from "./error-boundary";

const InternalError = () => {
  const { resetError } = useContext(ErrorContext);
  const navigate = useNavigate();
  const refreshPage = () => {
    resetError && resetError();
    navigate("/");
  };

  return (
    <div className="flex-1 flex flex-row text-center items-center pb-16 select-none mx-auto max-w-[674px]">
      <div className="flex-1 flex flex-col gap-3 items-center">
        <div className="flex flex-row items-center">
          <span className="font-bold text-[80px] md:text-[200px] inline-block">
            500
          </span>
        </div>

        <h1 className="font-bold text-xl md:text-[46px] md:leading-[60px] mb-[40px] tracking-[-0.08em]">
          Something went wrong.
        </h1>
        <p className="text-gray-700 text-lg mb-[40px]">
          We’re experiencing a temporary issue on our end. Please try again, or
          contact support if the problem persists.
        </p>

        <div>
          <button
            onClick={resetError}
            className="bg-brand-500 text-sm text-white px-6 py-2.5 rounded-2xl mr-2"
          >
            Retry
          </button>

          <Link
            onClick={refreshPage}
            className="border border-gray-700 text-sm text-navy-900 dark:text-white px-6 py-2.5 rounded-2xl"
          >
            Return to Homepage
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InternalError;
